import { Link } from "react-router-dom";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { Menu, Lock } from "lucide-react";
import { ICON_MAP, NAV_LINKS } from "./navConstants";

export function MobileMenu({ menuOpen, setMenuOpen, clubBadges, vereine, specialClubs, activeClub, setActiveClub, location, accentColor, isMemberLoggedIn }) {
  return (
    <Sheet open={menuOpen} onOpenChange={setMenuOpen}>
      <SheetTrigger asChild className="lg:hidden">
        <button className="p-2" data-testid="mobile-menu-trigger">
          <Menu className="w-6 h-6" />
        </button>
      </SheetTrigger>
      <SheetContent side="right" className="w-80 bg-background border-l border-white/10">
        <SheetTitle className="sr-only">Navigation</SheetTitle>
        <div className="flex flex-col gap-6 mt-8 overflow-y-auto max-h-[calc(100vh-4rem)] pb-8">
          <div className="flex items-center gap-3 flex-wrap">
            {clubBadges.map(club => {
              const Icon = ICON_MAP[club.icon];
              return (
                <button key={club.id} data-testid={`mobile-club-${club.id}`}
                  onClick={() => setActiveClub(activeClub === club.id ? null : club.id)}
                  className={`p-2 rounded-full border-2 ${activeClub === club.id ? '' : 'border-transparent opacity-50'}`}
                  style={{ color: club.accent, borderColor: activeClub === club.id ? club.accent : 'transparent' }}>
                  <Icon className="w-5 h-5" />
                </button>
              );
            })}
          </div>
          {NAV_LINKS.map(link => (
            <Link key={link.path} to={link.path} onClick={() => setMenuOpen(false)}
              data-testid={`mobile-nav-${link.path.replace('/', '') || 'home'}`}
              className={`text-lg font-semibold uppercase tracking-wider ${location.pathname === link.path ? '' : 'text-muted-foreground'}`}
              style={location.pathname === link.path ? { color: accentColor } : {}}>
              {link.label}
            </Link>
          ))}
          <div className="border-t border-white/10 pt-4">
            <p className="text-xs font-medium uppercase tracking-widest text-muted-foreground mb-3">Vereine</p>
            {vereine.map(club => (
              <Link key={club.id} to={`/club/${club.id}`}
                onClick={() => { setActiveClub(club.id); setMenuOpen(false); }}
                data-testid={`mobile-club-link-${club.id}`}
                className="flex items-center gap-2 py-2 text-muted-foreground hover:text-foreground">
                <div className="w-2 h-2 rounded-full" style={{ backgroundColor: club.accent }} />
                <span className="text-sm">{club.name}</span>
              </Link>
            ))}
          </div>
          <div className="border-t border-white/10 pt-4">
            <p className="text-xs font-medium uppercase tracking-widest text-muted-foreground mb-3">Mehr</p>
            {specialClubs.map(club => (
              <Link key={club.id} to={`/club/${club.id}`}
                onClick={() => { setActiveClub(club.id); setMenuOpen(false); }}
                data-testid={`mobile-special-link-${club.id}`}
                className="flex items-center gap-2 py-2 text-muted-foreground hover:text-foreground">
                <div className="w-2 h-2 rounded-full" style={{ backgroundColor: club.accent }} />
                <span className="text-sm">{club.name}</span>
              </Link>
            ))}
            <Link to="/ligaplatzierung" onClick={() => setMenuOpen(false)}
              className="flex items-center gap-2 py-2 text-muted-foreground hover:text-foreground"
              data-testid="mobile-liga-link">
              <div className="w-2 h-2 rounded-full bg-primary" />
              <span className="text-sm">Ligaplatzierung</span>
              {!isMemberLoggedIn && <Lock className="w-3 h-3 ml-auto text-muted-foreground" />}
            </Link>
            <Link to="/downloads" onClick={() => setMenuOpen(false)}
              className="flex items-center gap-2 py-2 text-muted-foreground hover:text-foreground"
              data-testid="mobile-downloads-link">
              <div className="w-2 h-2 rounded-full bg-primary" />
              <span className="text-sm">Downloads</span>
            </Link>
            <Link to={isMemberLoggedIn ? "/mitglied-portal" : "/mitglied-login"} onClick={() => setMenuOpen(false)}
              className="flex items-center gap-2 py-2 text-muted-foreground hover:text-foreground"
              data-testid="mobile-member-login-link">
              <div className="w-2 h-2 rounded-full" style={{ backgroundColor: '#fbbf24' }} />
              <span className="text-sm">{isMemberLoggedIn ? "Mitglieder-Portal" : "Mitglieder-Login"}</span>
              {!isMemberLoggedIn && <Lock className="w-3 h-3 ml-auto text-muted-foreground" />}
            </Link>
          </div>
          <div className="border-t border-white/10 pt-4">
            <p className="text-xs font-medium uppercase tracking-widest text-muted-foreground mb-3">Kontakt</p>
            <a href="tel:+437242216406" className="flex items-center gap-2 py-2 text-muted-foreground hover:text-foreground" data-testid="mobile-phone">
              <span className="text-sm">Tel: +43 (0)7242 216406</span>
            </a>
            <a href="mailto:office@ninersbillard.com" className="flex items-center gap-2 py-2 text-muted-foreground hover:text-foreground" data-testid="mobile-email">
              <span className="text-sm">office@ninersbillard.com</span>
            </a>
            <p className="text-xs text-muted-foreground mt-1">Stelzhamerstraße 9, 4600 Wels</p>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
